import type { DocumentItem } from '@/types';
import styles from './DocumentTile.module.css';

interface DocumentTileProps {
  item: DocumentItem;
}

export default function DocumentTile({ item }: DocumentTileProps) {
  return (
    <div className={styles.tile}>
      <div className={styles.preview}>
        <span className={`${styles.format} ${styles[item.format]}`}>
          {item.format.toUpperCase()}
        </span>
        <div className={styles.miniTitle}>{item.title}</div>
        <div className={styles.miniLine} />
        <div className={styles.miniLine} />
        <div className={`${styles.miniLine} ${styles.miniLineAccent}`} />
        <div className={`${styles.miniLine} ${styles.miniLineShort}`} />
        <div className={styles.miniLine} />
        {item.format === 'xlsx' || item.format === 'pptx' ? (
          <div className={styles.miniChart} />
        ) : (
          <>
            <div className={styles.miniLine} />
            <div className={`${styles.miniLine} ${styles.miniLineShort}`} />
          </>
        )}
      </div>
      <div className={styles.info}>
        <h5 className={styles.infoTitle}>{item.title}</h5>
        <div className={`${styles.infoMeta} ${item.meta?.includes('✓') ? styles.infoMetaOk : ''}`}>
          {item.meta}
        </div>
      </div>
    </div>
  );
}
